"use client";

import { motion } from "framer-motion";

export function Loading() {
  return (
    <div className="flex justify-center items-center w-full h-full">
      <motion.div
        animate={{ rotate: 360 }}
        className="w-16 h-16 relative"
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <motion.div
            key={index}
            className="absolute w-6 h-6 bg-teal-500 rounded-full"
            style={{
              top: index === 0 || index === 1 ? 0 : "auto",
              bottom: index === 2 || index === 3 ? 0 : "auto",
              left: index === 0 || index === 3 ? 0 : "auto",
              right: index === 1 || index === 2 ? 0 : "auto",
            }}
            animate={{ rotate: -360 }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "linear",
            }}
          />
        ))}
      </motion.div>
      <span className="sr-only">Carregando...</span>
    </div>
  );
}
